import React from 'react';
import { INotificationPopupProps } from './notification-popup.type';
import { NotificationPage } from '../../../../pages';
import classNames from 'classnames';
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import { routePaths } from '../../../../routes/routes-path';
import { NotificationComponent } from '../../../../pages/notification/notification.component';

export const NotificationPopup: React.FC<INotificationPopupProps> = ({
  visible,
  onClose,
}) => {
  return (
    <div
      // id="notification-item"
      className={classNames(
        `z-20 w-[500px] max-w-[calc(100vw-1.5rem)] sm:max-w-sm bg-[#edf0f3] divide-y divide-gray-100 rounded-lg shadow
         dark:bg-gray-800 dark:divide-gray-700`,
        {
          'hidden opacity-0': !visible,
          'visible opacity-100': visible,
        }
      )}
    >
      <div className="divide-y divide-gray-100 dark:divide-gray-700">
        <NotificationComponent onClose={onClose} />
      </div>
      <Link
        to={routePaths.notifications}
        className="block py-2 text-sm font-medium bg-[#edf0f3] text-center text-gray-900 rounded-b-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-white"
        onClick={() => {
          onClose?.();
        }}
      >
        <div className="flex  items-center justify-center gap-[2px] text-[#0057FF]">
          Xem tất cả
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.43994 13.2802L10.7866 8.93355C11.2999 8.42021 11.2999 7.58021 10.7866 7.06688L6.43994 2.72021"
              stroke="#0057FF"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </Link>
    </div>
  );
};
